import VueRouter from 'vue-router'

import Login from '@/views/Login'
import NotFound from '@/views/404'
import Home from '@/views/Home'

const getView = view => require(`@/views/${view}`).default

let routes = [
  {
    path: '/login',
    component: Login,
    name: 'Login',
    hidden: true,
    meta: {
      guests: true
    }
  },
  {
    path: '/404',
    component: NotFound,
    name: '404',
    hidden: true,
    meta: {
      guests: true
    }
  },
  {
    path: '/',
    component: Home,
    name: 'Home',
    iconCls: 'el-icon-star-on',
    meta: { label: 'Home' },
    redirect: {
      name: 'Dashboard'
    },
    hidden: true
  },
  {
    path: '/dashboard',
    component: Home,
    iconCls: 'el-icon-s-home',
    meta: { label: 'Dashboard' },
    children: [
      {
        path: '',
        component: getView('Dashboard/Dashboard'),
        name: 'Dashboard',
        iconCls: 'el-icon-star-on',
        meta: { label: 'Home' }
      }
    ]
  },
  {
    path: '/articles',
    component: Home,
    iconCls: 'fa fa-file-text-o',
    meta: { label: 'Artykuły' },
    children: [
      {
        path: '',
        component: getView('Articles/ArticlesList'),
        name: 'Article List',
        meta: { label: 'Lista artykułów' }
      },
      {
        path: 'add',
        component: getView('Articles/ArticleForm'),
        name: 'Add Article',
        meta: { label: 'Dodaj artykuł' }
      },
      {
        path: 'labels',
        component: getView('Articles/LabelList'),
        name: 'Label List',
        meta: { label: 'Lista etykiet' }
      },
      {
        path: 'labels/add',
        component: getView('Articles/LabelForm'),
        name: 'Add Label',
        meta: { label: 'Dodaj etykietę' }
      },
      {
        path: 'labels/:id',
        props: true,
        component: getView('Articles/LabelForm'),
        name: 'Edit Label',
        hidden: true,
        meta: { label: 'Edytuj etykietę' }
      },
      {
        path: ':id',
        props: true,
        component: getView('Articles/ArticleForm'),
        name: 'Edit Article',
        hidden: true,
        meta: { label: 'Edytuj artykuł' }
      }
    ]
  },
  {
    path: '/pages',
    component: Home,
    iconCls: 'fa fa-desktop',
    meta: { label: 'Podstrony' },
    children: [
      {
        path: '',
        component: getView('Pages/PagesList'),
        name: 'Pages List',
        meta: { label: 'Lista stron' }
      },
      {
        path: 'add',
        component: getView('Pages/PageForm'),
        name: 'Add Page',
        meta: { label: 'Dodaj stronę' }
      },
      {
        path: ':id',
        props: true,
        component: getView('Pages/PageForm'),
        name: 'Edit Page',
        hidden: true,
        meta: { label: 'Edytuj stronę' }
      }
    ]
  },
  {
    path: '/images',
    component: Home,
    iconCls: 'fa fa-image',
    meta: { label: 'Zdjęcia' },
    children: [
      {
        path: '',
        component: getView('Image/ImageList'),
        name: 'Image List',
        meta: { label: 'Lista zdjęć' }
      },
      {
        path: 'add',
        component: getView('Image/ImageForm'),
        name: 'Add Image',
        meta: { label: 'Dodaj zdjęcie' }
      },
      {
        path: ':id',
        props: true,
        component: getView('Image/ImageForm'),
        name: 'Edit Image',
        hidden: true,
        meta: { label: 'Edytuj zdjęcie' }
      }
    ]
  },
  {
    path: '/attachments',
    component: Home,
    iconCls: 'fa fa-download',
    meta: { label: 'Załączniki' },
    children: [
      {
        path: '',
        component: getView('Attachments/AttachmentsList'),
        name: 'Attachments List',
        meta: { label: 'Lista załączników' }
      }
    ]
  },
  {
    path: '/menu',
    component: Home,
    iconCls: 'fa fa-bars',
    meta: { label: 'Menu' },
    children: [
      {
        path: 'main-menu',
        props: {
          default: true,
          id: 'main-menu'
        },
        component: getView('Menus/MenuForm'),
        name: 'Edit Menu',
        meta: { label: 'Edytuj menu główne' }
      },
      {
        path: '',
        component: getView('Menus/CustomMenusList'),
        name: 'Custom Menu List',
        meta: { label: 'Lista menu' }
      },
      {
        path: 'add',
        component: getView('Menus/CustomMenuForm'),
        name: 'Add Custom Menu',
        meta: { label: 'Dodaj menu' }
      },
      {
        path: ':id',
        props: true,
        component: getView('Menus/CustomMenuForm'),
        name: 'Edit Custom Menu',
        hidden: true,
        meta: { label: 'Edytuj menu' }
      }
    ]
  },
  {
    path: '/users',
    component: Home,
    iconCls: 'fa fa-group',
    meta: { label: 'Użytkownicy' },
    children: [
      {
        path: '',
        component: getView('User/UserList'),
        name: 'User List',
        meta: { label: 'Lista użytkowników' }
      },
      {
        path: 'add',
        component: getView('User/UserForm'),
        name: 'Add User',
        meta: { label: 'Dodaj użytkownika' }
      },
      {
        path: ':id',
        props: true,
        component: getView('User/UserForm'),
        name: 'Edit User',
        hidden: true,
        meta: { label: 'Edytuj użytkownika' }
      }
    ]
  },
  {
    path: '/settings',
    component: Home,
    iconCls: 'fa fa-cog',
    meta: { label: 'Ustawienia' },
    children: [
      {
        path: '',
        component: getView('Settings/SettingsForm'),
        name: 'Settings Form',
        meta: { label: 'Konfiguracja strony' }
      }
    ]
  },
  {
    path: '*',
    hidden: true,
    redirect: { path: '/404' }
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  const isUserLoggedIn = window.localStorage.getItem('token')
  if (!to.meta.guests && !isUserLoggedIn) {
    next({ name: 'Login', query: { next: to.path } })
    return
  }
  document.title = to.meta.label
    ? `${to.meta.label} - Panel administracyjny`
    : 'Panel administracyjny'
  next()
})

export default router
